// Checkea si un string existe como la propiedad de un objeto
export default function isObjKey<T>(key: any, obj: T): key is keyof T {
  return key in obj;
}
